/**
 * Format raw SQL / API column keys into readable table headers.
 */
export function formatSqlColumnHeader(col) {
  if (!col) return "";
  const knownSplits = {
    yearmonth: "Year Month",
    firstname: "First Name",
    lastname: "Last Name",
    brandname: "Brand Name",
    totalvalue: "Total Value",
    totalsales: "Total Sales",
    netvalue: "Net Value",
    hqname: "HQ Name",
    productname: "Product Name",
    orderdate: "Order Date",
    startdate: "Start Date",
    enddate: "End Date",
    createdat: "Created At",
    updatedat: "Updated At",
    unitprice: "Unit Price",
    salesperson: "Sales Person",
    customerid: "Customer ID",
    orderid: "Order ID",
    productid: "Product ID",
  };
  let header = col.replace(/_/g, " ").trim();
  const lower = header.toLowerCase().replace(/\s+/g, "");
  if (knownSplits[lower]) return knownSplits[lower];
  return header
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}
